
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M509.7 498.3L360.5 349.1c34.3-37 55.5-86.5 55.5-141.1C416 93.13 322.9 0 208 0S0 93.13 0 208s93.13 208 208 208c54.55 0 104.1-21.17 141.2-55.54l149.2 149.2c1.5 1.54 3.5 2.34 5.6 2.34s4.094-.781 5.656-2.344c3.144-3.156 3.144-8.156.044-11.356zM208 400c-105.9 0-192-86.13-192-192S102.13 16 208 16s192 86.13 192 192-86.1 192-192 192zm88-200H120c-4.4 0-8 3.6-8 8s3.578 8 8 8h176c4.42 0 8-3.578 8-8s-3.6-8-8-8z"}})])
          )
        }
      }
    